module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\n%><div><%\n%><%- include('./text', { model: { dataTEXT: model.location, atom: { dataType: 'text' }, fieldCode: 'location', titleKey: 'form.fields.location.location.title', config: fieldConfig.fields.location || {}}}) %><%\n%><div class=\"controls\"><%\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'openLocation', context: 'location', mode: '', symbolOnly: true, usage: true } }); %><%\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'locationOptions', mode: '', symbolOnly: true } }); %><%\n%></div><%\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\location.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}

    ; __line = 3
    ; __append("<div>")
    ; 

    ; __line = 4
    ; __append( include('./text', { model: { dataTEXT: model.location, atom: { dataType: 'text' }, fieldCode: 'location', titleKey: 'form.fields.location.location.title', config: fieldConfig.fields.location || {}}}) )
    ; 

    ; __line = 5
    ; __append("<div class=\"controls\">")
    ; 

    ; __line = 6
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'openLocation', context: 'location', mode: '', symbolOnly: true, usage: true } }) )
    ; 

    ; __line = 7
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'locationOptions', mode: '', symbolOnly: true } }) )
    ; 

    ; __line = 8
    ; __append("</div>")
    ; 

    ; __line = 9
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\location.ejs

}